export const enClients = {
  "our": "OUR",
  "title": "CLIENTS",
  "subTitle": "THOSE WHO TRUST OUR WORK",
  "description": "We are proud to work with clients who place their trust in us. Their confidence drives us to deliver innovative, reliable, and high-quality solutions every day.",
client1: {
    name: "Meublatex Tunisia",
    description: "Meublatex Tunisia, manufacturer of mattresses, bedding, and furniture, delivers quality products combining comfort, durability, and design."
  },
  client2: {
    name: "Voyages 2000",
    description: "Voyages 2000 is a travel agency offering personalized trips, tours, and vacation packages, providing travelers with unique experiences and quality service."
  },
   client3: {
    name: "Livro Clic",
    description: "Livro Clic is a company specializing in the delivery of drinking water to homes, providing a fast, reliable, and convenient service to meet the daily needs of individuals and businesses."
  },
  client4: {
    name: "Brima Souk",
    description: "Brima Souk is a company and online platform dedicated to the sale of handcrafted products, serving as a showcase for artisans to present and promote their creations."
  },
  client5: {
    name: "2Drops",
    description: "2drops is a company specializing in car washing and oil changes, offering its services at stations and at home for more comfort and flexibility."
  },
  client6: {
    name: "Gamrenov",
    description: "Gamrenov is a construction company specializing in building, renovation, and development, offering quality services tailored to the needs of individuals and professionals."
  },
 
  
  
};

export const frClients = {
  "our": "NOS",
  "title": "CLIENTS",
  "subTitle": "CEUX QUI FONT CONFIANCE À NOTRE TRAVAIL",
  "description": "Nous sommes fiers de travailler avec des clients qui nous font confiance. Leur confiance nous pousse à fournir des solutions innovantes, fiables et de haute qualité chaque jour.",

  client1: {
    name: "Meublatex Tunisie",
    description: "Meublatex Tunisie, fabricant de matelas, literie et meubles, offre des produits de qualité alliant confort, durabilité et design."
  },
  client2: {
    name: "Voyages 2000",
    description: "Voyages 2000 est une agence de voyages proposant des séjours, circuits et forfaits vacances personnalisés, offrant aux voyageurs des expériences uniques et un service de qualité."
  },
   client3: {
    name: "Livro Clic",
    description: "Livro Clic est une entreprise spécialisée dans la livraison d'eau potable à domicile, offrant un service rapide, fiable et pratique pour répondre aux besoins quotidiens des particuliers et des entreprises."
  },
  client4: {
    name: "Brima Souk",
    description: "Brima Souk est une entreprise et une plateforme en ligne dédiée à la vente de produits artisanaux, servant de vitrine aux artisans pour présenter et promouvoir leurs créations."
  },
  client5: {
    name: "2Drops",
    description: "2drops est une entreprise spécialisée dans le lavage de voitures et les vidanges, offrant ses services en station et à domicile pour plus de confort et de flexibilité."
  },
  client6: {
    name: "Gamrenov",
    description: "Gamrenov est une entreprise de construction spécialisée dans la construction, la rénovation et le développement, offrant des services de qualité adaptés aux besoins des particuliers et des professionnels."
  },
};

export const nlClients = {
  "our": "ONZE",
  "title": "KLANTEN",
  "subTitle": "DIEGENEN DIE VERTROUWEN HEBBEN IN ONS WERK",
  "description": "We zijn er trots op samen te werken met klanten die ons vertrouwen. Hun vertrouwen drijft ons om elke dag innovatieve, betrouwbare en hoogwaardige oplossingen te leveren.",
  client1: {
    name: "Meublatex Tunesië",
    description: "Meublatex Tunesië, fabrikant van matrassen, beddengoed en meubels, biedt kwaliteitsproducten die comfort, duurzaamheid en design combineren."
  },
  client2: {
    name: "Voyages 2000",
    description: "Voyages 2000 is een reisbureau dat gepersonaliseerde reizen, rondleidingen en vakantiepakketten aanbiedt, en reizigers unieke ervaringen en kwaliteitsservice biedt."
  },
   client3: {
    name: "Livro Clic",
    description: "Livro Clic is een bedrijf dat gespecialiseerd is in de levering van drinkwater aan huis, en een snelle, betrouwbare en handige service biedt om te voldoen aan de dagelijkse behoeften van particulieren en bedrijven."
  },
  client4: {
    name: "Brima Souk",
    description: "Brima Souk is een bedrijf en online platform dat zich toelegt op de verkoop van ambachtelijke producten, en fungeert als etalage voor ambachtslieden om hun creaties te presenteren en te promoten."
  },
  client5: {
    name: "2Drops",
    description: "2drops is een bedrijf dat gespecialiseerd is in autowassen en olieverversing, en zijn diensten aanbiedt bij tankstations en aan huis voor meer comfort en flexibiliteit."
  },
  client6: {
    name: "Gamrenov",
    description: "Gamrenov is een bouwbedrijf dat gespecialiseerd is in bouwen, renoveren en ontwikkelen, en kwaliteitsdiensten aanbiedt die zijn afgestemd op de behoeften van particulieren en professionals."
  },

};
export const deClients = {
  "our": "UNSERE",
  "title": "KUNDEN",
  "subTitle": "DIEJENIGEN, DIE UNSERER ARBEIT VERTRAUEN",
  "description": "Wir sind stolz darauf, mit Kunden zusammenzuarbeiten, die uns vertrauen. Ihr Vertrauen treibt uns jeden Tag dazu an, innovative, zuverlässige und hochwertige Lösungen zu liefern.",
  client1: {
    name: "Meublatex Tunesien",
    description: "Meublatex Tunesien, Hersteller von Matratzen, Bettwaren und Möbeln, liefert Qualitätsprodukte, die Komfort, Langlebigkeit und Design vereinen."
  },
  client2: {
    name: "Voyages 2000",
    description: "Voyages 2000 ist ein Reisebüro, das personalisierte Reisen, Touren und Urlaubspakete anbietet und Reisenden einzigartige Erlebnisse und Qualitätsservice bietet."
  },
   client3: {
    name: "Livro Clic",
    description: "Livro Clic ist ein Unternehmen, das auf die Lieferung von Trinkwasser nach Hause spezialisiert ist und einen schnellen, zuverlässigen und praktischen Service bietet, um den täglichen Bedürfnissen von Privatpersonen und Unternehmen gerecht zu werden."
  },
  client4: {
    name: "Brima Souk",
    description: "Brima Souk ist ein Unternehmen und eine Online-Plattform, die sich dem Verkauf von handgefertigten Produkten widmet und als Schaufenster für Handwerker dient, um ihre Kreationen zu präsentieren und zu fördern."
  },
  client5: {
    name: "2Drops",
    description: "2Drops ist ein Unternehmen, das auf Autowäsche und Ölwechsel spezialisiert ist und seine Dienstleistungen an Tankstellen und zu Hause für mehr Komfort und Flexibilität anbietet."
  },
  client6: {
    name: "Gamrenov",
    description: "Gamrenov ist ein Bauunternehmen, das sich auf Bau, Renovierung und Entwicklung spezialisiert hat und qualitativ hochwertige Dienstleistungen anbietet, die auf die Bedürfnisse von Privatpersonen und Fachleuten zugeschnitten sind."
  },
};